import React, { Component, Fragment } from "react"
import styles from "./styles"
import { withStyles } from "@material-ui/styles"
import {
  Typography,
  Hidden,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Divider,
  Icon,
} from "@material-ui/core"
import ScheduleIcon from "@material-ui/icons/Schedule"
import AutoComplete from "../../components/AutoComplete"
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import MomentUtils from "@date-io/moment"

// function that filters shoot based on startDate and endDate
const dateFunc = (shoots, startDate, endDate) => {
  return shoots.filter(x => {
    const shootDate = new Date(x.start_date).getTime()
    return shootDate >= startDate && shootDate <= endDate
  })
}

const date = new Date()

export const dateOptions = [
  {
    id: 1,
    name: "At any time",
    func: shoots => shoots,
  },
  {
    id: 2,
    name: "Specific Range",
    func: shoots => {
      return dateFunc(shoots, new Date().getTime(), new Date().getTime())
    },
    showSpecific: true,
  },
  {
    id: 3,
    name: "Last 30 Days",
    func: shoots =>
      dateFunc(shoots, new Date().setDate(date.getDate() - 30), date.getTime()),
  },
  {
    id: 4,
    name: "Next 30 Days",
    func: shoots =>
      dateFunc(shoots, date.getTime(), new Date().setDate(date.getDate() + 30)),
  },
  {
    id: 5,
    name: "Last 7 Days",
    func: shoots =>
      dateFunc(shoots, new Date().setDate(date.getDate() - 7), date.getTime()),
  },
  {
    id: 6,
    name: "Next 7 Days",
    func: shoots =>
      dateFunc(shoots, date.getTime(), new Date().setDate(date.getDate() + 7)),
  },
  {
    id: 7,
    name: "Last Calendar Year",
    func: shoots =>
      dateFunc(
        shoots,
        new Date(date.getFullYear() - 1, 0),
        new Date(date.getFullYear(), 0)
      ),
  },
  {
    id: 8,
    name: "This Calendar Year",
    func: shoots =>
      dateFunc(
        shoots,
        new Date(date.getFullYear(), 0),
        new Date(date.getFullYear() + 1, 0)
      ),
  },
]

class DateFilter extends Component {
  state = {
    startDate: new Date(),
    endDate: new Date(),
    sortMenuAnchorEl: null,
  }
  componentDidMount() {
    if (localStorage.startDate) {
      const startDate = localStorage.getItem("startDate")
      this.setState({ startDate: startDate })
    }
    if (localStorage.endDate) {
      const endDate = localStorage.getItem("endDate")
      this.setState({ endDate: endDate })
    }
  }
  componentDidUpdate() {
    // set a dateFilter because it starts as null
    if (!this.props.dateFilter) {
      this.props.setState(dateOptions[0])
    }
  }

  handleOpenMenu = (e, name) => {
    this.setState({ [`${name}MenuAnchorEl`]: e.currentTarget })
  }
  handleCloseMenu = name => {
    this.setState({ [`${name}MenuAnchorEl`]: null })
  }

  setDate = (date, name) => {
    this.setState({ [name]: date.format("YYYY-MM-DD HH:mm:ss") })
    const dateOption = dateOptions.filter(
      x => x.id === this.props.dateFilter.id
    )[0]
    setTimeout(() => {
      dateOption.func = shoots =>
        dateFunc(
          shoots,
          new Date(this.state.startDate).getTime(),
          new Date(this.state.endDate).getTime()
        )
      this.props.setDate(this.state.startDate, this.state.endDate)

      this.props.setState(dateOption)
    }, 200)
  }
  render() {
    const { props, state } = this
    const { setState, dateFilter } = props
    const { startDate, endDate, sortMenuAnchorEl } = state

    return (
      <Fragment>
        {/* //// WEB VIEW //// */}
        <Hidden smDown>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "16px",
            }}
          >
            <Typography style={{ marginRight: "16px" }}>
              Shoot Date:{" "}
            </Typography>
            <AutoComplete
              openMenuOnClick={true}
              defaultOptions={dateOptions}
              showValue
              value={dateFilter}
              // suggestions={dateOptions}
              labelKey="name"
              onChange={id => {
                setState(dateOptions.find(x => x.id === id))
              }}
            />
            {dateFilter &&
              dateFilter.showSpecific && (
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <DatePicker
                    style={{ marginLeft: "32px" }}
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="Start Date"
                    margin="dense"
                    value={startDate}
                    onChange={e => this.setDate(e, "startDate")}
                  />
                  <DatePicker
                    style={{ marginLeft: "32px" }}
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="End Date"
                    margin="dense"
                    value={endDate}
                    onChange={e => this.setDate(e, "endDate")}
                    minDate={startDate}
                    minDateMessage={`End date should not be before the start date`}
                  />
                </MuiPickersUtilsProvider>
              )}
          </div>
        </Hidden>
        {/* //// MOBILE VIEW //// */}
        <Hidden mdUp>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "16px",
            }}
          >
            <IconButton
              className={this.props.classes.sortButton}
              onClick={e => this.handleOpenMenu(e, "sort")}
            >
              <ScheduleIcon />
            </IconButton>
            <Menu
              anchorEl={sortMenuAnchorEl}
              open={Boolean(sortMenuAnchorEl)}
              onClose={() => this.handleCloseMenu("sort")}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem>
                <Typography style={{ fontWeight: "bold" }}>
                  Filter By Date:
                </Typography>
              </MenuItem>
              <Divider />
              {dateFilter && dateFilter.showSpecific ? (
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <MenuItem
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <DatePicker
                      style={{ marginTop: 20 }}
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      label="Start Date"
                      margin="dense"
                      value={startDate}
                      onChange={e => this.setDate(e, "startDate")}
                    />
                    <DatePicker
                      style={{ marginTop: 20 }}
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      label="End Date"
                      margin="dense"
                      value={endDate}
                      onChange={e => this.setDate(e, "endDate")}
                      minDate={startDate}
                      minDateMessage={`End date should not be before the start date`}
                    />
                  </MenuItem>
                  <MenuItem onClick={() => setState(dateOptions[0])}>
                    <Tooltip title="remove filter" placement="top">
                      <Icon
                        color="primary"
                        style={{ fontSize: 20, marginRight: 8 }}
                      >
                        close
                      </Icon>
                    </Tooltip>
                    <Typography color="primary">Clear Filter</Typography>
                  </MenuItem>
                </MuiPickersUtilsProvider>
              ) : (
                dateOptions.map((option, i) => (
                  <MenuItem
                    key={i}
                    onClick={() => {
                      setState(dateOptions.find(x => x.id === option.id))
                      if (option.id !== 2) {
                        this.handleCloseMenu("sort")
                      }
                    }}
                  >
                    {option.name}
                  </MenuItem>
                ))
              )}
            </Menu>
          </div>
        </Hidden>
      </Fragment>
    )
  }
}

DateFilter.options = dateOptions

export default withStyles(styles)(DateFilter)
